import { render, staticRenderFns } from "./TurmasMultiseriadas.vue?vue&type=template&id=517c6e01"
import script from "./TurmasMultiseriadas.vue?vue&type=script&lang=ts"
export * from "./TurmasMultiseriadas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports